<div class="pendent">
  <div class="details">
    {{ frequency?.name }}
    <br />
    <div class="date">{{ frequency?.theme }} ({{ frequency?.created_at | date: 'dd/MM/yyyy' }})</div>
  </div>
  <div class="details">
    <button class="start-frequency" (click)="startFrequency(frequency.group_word_id, frequency.group_id)">
      Inicia chamada<img src="../../../assets/icons/play_white.svg" />
    </button>
  </div>
</div>
